export default __webpack_public_path__ + "static/media/HospitalService.461b8654.svg";